import { getDefaultFilterFn } from './commonListTableDefaults';

import type { PipesTableFilter } from '../types/pipesList.types';

export const filterLabelMapping = {
  _id: 'Pipe',
  name: 'Name',
  'config.effective.source.system': 'From',
  'lineage.upstreamPipeOrSystem': 'Reads from',
  'config.effective.source.type': 'Source type',
  'config.effective.sink.system': 'To',
  'lineage.downstreamPipeOrSystem': 'Read by',
  'config.effective.sink.type': 'Sink type',
  direction: 'Direction',
  origin: 'Origin',
  'runtime.state': 'State',
  tags: 'Tags',
  pumpMode: 'Pump mode',
  global: 'Global',
  lastRunStatus: 'Last run status',
  configGroup: 'Config group',
  durable: 'Durable',
  tenant: 'Tenant',
  transforms: 'Transforms',
};

export const emptyFilterPipes: PipesTableFilter = {
  _id: {
    selected: [],
    search: [],
  },
  name: {
    selected: [],
    search: [],
  },
  'config.effective.source.system': {
    selected: [],
    search: [],
  },
  'lineage.upstreamPipeOrSystem': {
    selected: [],
    search: [],
  },
  'config.effective.source.type': {
    selected: [],
    search: [],
  },
  'config.effective.sink.system': {
    selected: [],
    search: [],
  },
  'lineage.downstreamPipeOrSystem': {
    selected: [],
    search: [],
  },
  'config.effective.sink.type': {
    selected: [],
    search: [],
  },
  direction: {
    selected: [],
    search: [],
  },
  origin: {
    selected: [],
    search: [],
  },
  'runtime.state': {
    selected: [],
    search: [],
  },
  tags: {
    selected: [],
    search: [],
  },
  pumpMode: {
    selected: [],
    search: [],
  },
  global: {
    selected: [],
    search: [],
  },
  lastRunStatus: {
    selected: [],
    search: [],
  },
  configGroup: {
    selected: [],
    search: [],
  },
  durable: {
    selected: [],
    search: [],
  },
  tenant: {
    selected: [],
    search: [],
  },
  transforms: {
    selected: [],
    search: [],
  },
} as const;

export const getPipesDefaultFilter = getDefaultFilterFn(emptyFilterPipes);

export const defaultVisibleCols = [
  'Pipe',
  'Enabled',
  'Progress',
  'Next run',
  'Last run',
  'Bytes used',
  'Config',
];

export const defaultVisibleFacets = [
  '_id',
  'lineage.upstreamPipeOrSystem',
  'config.effective.source.system',
  'config.effective.sink.system',
  'origin',
];

export const defaultSortBy = [
  {
    id: 'pipes-link',
    desc: false,
  },
];
